/* eslint-disable import/no-extraneous-dependencies */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { parseURL, buildParams } from '../../global/js/url';
import SearchContext from '../../funnelback-instant-search/jsx/data/FunnelbackContext';

import styles from '../css/functional.module.scss';

/**
 * Search Info Component.
 *
 * @param {string} resultPage A link to search page
 *
 * @returns {JSX.Element}
 * @constructor
 */
function SearchInfo({ resultPage }) {
    const { fetchResults, isFetching, searchTerm, qsups, queryString } = useContext(SearchContext);
    const infoParams = {
        qsup: 'off',
    };
    const urlParams = parseURL(queryString || '');
    const newParams = buildParams({ ...urlParams, ...infoParams }, true, true);

    const onClickHandler = (event) => {
        fetchResults(event, newParams);
    };

    if (isFetching || qsups.length === 0) {
        return '';
    }
    return (
        <div className={`search-box__info ${styles.searchBoxInfo}`}>
            <svg className={`search-box__icon ${styles.searchBoxIcon} ${styles.searchBoxInfoIcon}`}>
                <use href="#information" />
            </svg>
            <p className="search-box__desc">
                Your query has been expanded to{' '}
                {qsups.map((sup, index) => {
                    let spacer = '';
                    if (index > 0) {
                        spacer = ', ';
                    }
                    return sup.query + spacer;
                })}
                . Search for{' '}
                <a href={`${resultPage}${newParams}`} className="search-box__link" onClick={onClickHandler}>
                    <strong>{searchTerm}</strong>
                </a>{' '}
                instead.
            </p>
        </div>
    );
}

/**
 * Prop Types for SearchBoxComponent.
 *
 * @type {Object}
 */
SearchInfo.propTypes = {
    resultPage: PropTypes.string,
};

SearchInfo.defaultProps = {
    resultPage: '',
};

export default SearchInfo;
